import React, { useState, useEffect } from "react";
import _ from "lodash";
import "./styles/base.css";
import SelfieSearch from "./SelfieSearch";
import { SelfieSearchContext } from "../MasterImageSearch/components/SelfieSearchContext";
import SelfieUploadPopup from "../MasterImageSearch/components/SelfieUploadPopup";
import ajax from "superagent";
import { Tag } from "./types";
const wave = require("../common/images/wave.svg");
const gssNewLoader = require("../../assets/gss-loader.gif");
import Telemetry from "../../utils/rudderstackAnalytics";

const SearchOptions = ({
  selfieUploadPopup,
  toggleSelfieUploadPopup,
  imageThumbnail,
  removeSelfie,
  updateEventFilter,
  updateLocationFilter,
  updateImageFilter,
  adminUser,
  selfieSearchS3Bucket,
  currentUserId,
  currentUserCountry,
  clearSearch,
  resetClearSearch,
  addTagToFilter,
  canManageTags,
  selfieSearchAvailable,
  pageConfiguration,
  openSellYourPhotos,
  showSellYourPhotosBtn
}: {
  selfieUploadPopup: boolean;
  toggleSelfieUploadPopup: Function;
  imageThumbnail: string | null;
  removeSelfie: Function;
  updateEventFilter: (eventName: string) => void;
  updateLocationFilter: (eventName: string) => void;
  updateImageFilter: (imageUrl: string | null, clearSelfie: boolean) => void;
  adminUser: boolean;
  selfieSearchS3Bucket: string;
  currentUserId: number;
  currentUserCountry: string;
  clearSearch: boolean;
  resetClearSearch: Function;
  addTagToFilter: (tag: Tag) => void;
  canManageTags: boolean;
  selfieSearchAvailable: boolean;
  pageConfiguration: {
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
  };
  openSellYourPhotos: Function;
  showSellYourPhotosBtn: boolean;
}) => {
  const eventNameRef: any = React.createRef();
  const locationRef: any = React.createRef();
  const tagRef: any = React.createRef();
  const [tagName, setTagName] = React.useState("");
  const [matchingTags, setMatchingTags] = React.useState<Array<Tag>>([]);
  const [loading, setLoading] = useState(false);
  const [noResult, setNoResult] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(true);

  useEffect(() => {
    if (clearSearch) {
      eventNameRef.current.value = "";
      locationRef.current.value = "";
      resetClearSearch();
    }
  }, [clearSearch]);

  useEffect(() => {
    if (!canManageTags) return;

    setNoResult(false);
    if (tagRef.current.value.length > 0) setLoading(true);

    const setupKeywordsAutosuggest = () => {
      // @ts-ignore
      ajax
        .get("/api/v1/tags")
        .query({
          name: tagName
        })
        .then((res: any) => {
          if (res.body.matchingTags.length === 0) {
            setNoResult(true);
          }
          setMatchingTags([...res.body.matchingTags]);
          setLoading(false);
        });
    };
    if (tagName.length > 0) setupKeywordsAutosuggest();
    else setMatchingTags([]);
  }, [tagName]);

  const debouncedEventNameFilter = _.debounce(function (e) {
    updateEventFilter(eventNameRef.current.value);
  }, 750);
  const debouncedLocationFilter = _.debounce(function (e) {
    updateLocationFilter(locationRef.current.value);
  }, 750);
  const debouncedTagFilter = _.debounce(function (e) {
    setTagName(tagRef.current.value);
  }, 750);

  const addTagToSearch = function (tag: Tag) {
    setTagName("");
    tagRef.current.value = "";
    setMatchingTags([]);
    addTagToFilter(tag);
  };
  useEffect(() => {
    if (!currentUserId) {
      Telemetry.track(
        "internal-referrals:org-gallery-sell-your-photos-referral-btn-shown"
      );
    }
  }, []);

  return (
    <div className="container">
      <div className="orgevents-search-area">
        <div className="orgevents-search-left geo-form">
          <div className="geo-form__input-wrap geo-form__pbg">
            <i className="fa fa-search"></i>
            <input
              placeholder="Search by Event Name"
              ref={eventNameRef}
              onChange={debouncedEventNameFilter}
              className="geo-form__input"
            />{" "}
          </div>
          <div className="geo-form__input-wrap geo-form__pbg">
            <i className="fa fa-map-marker"></i>
            <input
              placeholder="Search by Location"
              ref={locationRef}
              onChange={debouncedLocationFilter}
              className="geo-form__input"
            />
          </div>
          {selfieSearchAvailable && (
            <SelfieSearch
              openSelfieUploadPopup={toggleSelfieUploadPopup}
              imageThumbnail={imageThumbnail}
              removeSelfie={removeSelfie}
            />
          )}

          {canManageTags && (
            <div className="geo-form__input-wrap geo-form__pbg geo-tag__filter">
              <i className="fa fa-filter"></i>
              <input
                id="search-tags"
                placeholder="Search by Tag Name"
                ref={tagRef}
                onChange={debouncedTagFilter}
                className="geo-form__input"
              />
              {noResult ? (
                <ul className="geo-tags__auto dropdown-list">
                  <li>No results found</li>
                </ul>
              ) : (
                <ul className="geo-tags__auto dropdown-list">
                  {loading ? (
                    <div className="gss-circle-loader album-container ">
                      <i className="fa fa-spin fa-circle-o-notch"></i>
                    </div>
                  ) : (
                    matchingTags.length > 0 &&
                    matchingTags.map((tag: any, index: number) => (
                      <li key={index} onClick={() => addTagToSearch(tag)}>
                        {tag.name}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </div>
          )}
        </div>
        <SelfieSearchContext.Provider
          value={{
            adminUser: adminUser,
            selfieSearchS3Bucket: selfieSearchS3Bucket,
            currentUserId: currentUserId,
            currentUserCountry: currentUserCountry,
            openSelfieUploadPopup: () => toggleSelfieUploadPopup(),
            referenceImage: imageThumbnail,
            pageConfiguration: pageConfiguration
          }}
        >
          {selfieUploadPopup && (
            <SelfieUploadPopup
              updateImageFilter={(imageUrl, val) =>
                updateImageFilter(imageUrl, val)
              }
              closePopup={() => toggleSelfieUploadPopup()}
              hideUploadSelfie={false}
            />
          )}
        </SelfieSearchContext.Provider>
        <div className="orgevents-search-right">
          {showSellYourPhotosBtn && (
            <div
              className="invite-ph-box"
              onClick={() => {
                Telemetry.track(
                  "internal-referrals:org-gallery-sell-your-photos-referral-clicked"
                );
                openSellYourPhotos();
              }}
            >
              <img src={wave} />
              <div> Sell your photos</div>
            </div>
          )}
          <div className="geo-branding">
            <a href="https://geosnapshot.com" target="_blank">
              <div className="dv-logoImg"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchOptions;
